import { DeleteFilled, LoadingOutlined } from '@ant-design/icons'
import { type RunStatus, useRouteOptimization } from '@hooks/useRouteOptimization'
import { GraviButton, NotificationMessage } from '@gravitate-js/excalibrr'
import { Popconfirm } from 'antd'
import { useMemo, useState } from 'react'
import { useAutoDispatch } from '@api/useAutoDispatch'
import type { CancelRunButtonProps } from '../types'

export function CancelRunButton({ selectedRunId, createdBy, width, resetOptimizer }: CancelRunButtonProps) {
  const [loading, setLoading] = useState(false)
  const [cancelPopVisible, setCancelPopVisible] = useState(false)
  const { automatedDispatchCancel } = useAutoDispatch()
  const { userRunState, runStatus } = useRouteOptimization()

  const showPopOnCancel = useMemo(() => {
    const run = runStatus?.find((run: RunStatus) => run.run_id === selectedRunId)
    const username = localStorage.getItem('user')
    return run?.created_by !== username
  }, [selectedRunId, userRunState, runStatus])

  const handleCancelRun = async () => {
    setLoading(true)
    try {
      await automatedDispatchCancel.mutateAsync(selectedRunId)
    } catch (e) {
      NotificationMessage('Run Failed.', 'This run could not be cancelled. Please try again.')
    } finally {
      resetOptimizer()
      setLoading(false)
    }
  }
  const cancelOptimizerRun = () => {
    if (showPopOnCancel) {
      setCancelPopVisible(true)
    } else {
      handleCancelRun()
    }
  }

  return (
    <Popconfirm
      title={`Are you sure you want to cancel this run created by ${createdBy}?`}
      visible={cancelPopVisible}
      onConfirm={handleCancelRun}
      onCancel={() => setCancelPopVisible(false)}
      okText='Yes'
      cancelText='No'
    >
      <GraviButton
        disabled={loading}
        className='m-1 mr-4 optimizer-run-button'
        error
        buttonText={
          <>
            {loading ? <LoadingOutlined className='mr-3' /> : <DeleteFilled className='mr-3' />}
            CANCEL
          </>
        }
        onClick={cancelOptimizerRun}
        style={width ? { width } : {}}
      />
    </Popconfirm>
  )
}
